import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Shield } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
export function FinalCTA() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-navy-primary py-20 px-4" data-id="element-85">
      <div className="max-w-4xl mx-auto text-center" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-87">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-6" data-id="element-88">
            พร้อมที่จะเปลี่ยนแปลงการสอนของคุณแล้วหรือยัง?
          </h2>
          <p className="text-xl text-gray-300 mb-8" data-id="element-89">
            เข้าร่วมกับอาจารย์กว่า 1,200 ท่านที่เลือกใช้ระบบนี้
          </p>

          <CTAButton onClick={scrollToOffer} size="large" className="mb-6" data-id="element-90">
            ⚽ ใช่! ฉันต้องการคืนเวลาของตัวเอง
            <br data-id="element-91" />
            และสอนฟุตบอลได้อย่างมืออาชีพ
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-300" data-id="element-92">
            <span className="flex items-center gap-1" data-id="element-93">
              <Zap className="w-4 h-4 text-gold-accent" data-id="element-94" />
              เข้าถึงได้ทันที
            </span>
            <span className="flex items-center gap-1" data-id="element-95">
              <Shield className="w-4 h-4 text-gold-accent" data-id="element-96" />
              รับประกัน 7 วัน
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}